/* AMK: show only the images of the selected colour + an "Alle farver" overview. Albino Monkey, 2026-10-05 */
(function () {
  var COLOR_RE = /i farven ([^,]+)/i;
  function norm(s) { return (s || '').toLowerCase().trim(); }
  function colorOf(el) {
    var img = el && el.querySelector('img');
    var m = img && COLOR_RE.exec(img.getAttribute('alt') || '');
    return m ? norm(m[1]) : null;
  }
  function colorFieldset(root) {
    var sets = root.querySelectorAll('fieldset.product-form__input');
    for (var i = 0; i < sets.length; i++) {
      var lg = sets[i].querySelector('legend');
      if (lg && /farve/i.test(lg.textContent)) return sets[i];
    }
    return null;
  }
  function selectedColor(fs) {
    var c = fs && fs.querySelector('input[type=radio]:checked');
    return c ? norm(c.value) : null;
  }
  function apply(root) {
    var gallery = root.querySelector('media-gallery');
    var fs = colorFieldset(root);
    if (!gallery || !fs) return;
    var color = selectedColor(fs);
    if (!color) return;
    var viewer = gallery.querySelector('[id^="GalleryViewer"]');
    var thumbs = gallery.querySelector('[id^="GalleryThumbnails"]');
    var items = viewer ? viewer.querySelectorAll('li[data-media-id]') : [];
    var hasColorImages = false;
    items.forEach(function (li) { if (colorOf(li)) hasColorImages = true; });
    if (!hasColorImages) return;
    var dirty = false;
    items.forEach(function (li) {
      var c = colorOf(li);
      var shouldHide = !!c && c !== color;
      if (li.classList.contains('amk-hide') !== shouldHide) dirty = true;
    });
    if (!dirty && root._amkColor === color) {
      var act = viewer.querySelector('li[data-media-id].is-active');
      if (!act || act.classList.contains('amk-hide')) {
        var fv = viewer.querySelector('li[data-media-id]:not(.amk-hide)');
        if (fv && gallery.setActiveMedia) gallery.setActiveMedia(fv.dataset.mediaId, false);
      }
      markOverview(root, color); return;
    }
    root._amkColor = color;
    var firstVisible = null, activeHidden = false;
    items.forEach(function (li) {
      var c = colorOf(li);
      var show = !c || c === color;
      li.classList.toggle('amk-hide', !show);
      if (show && !firstVisible) firstVisible = li;
      if (!show && li.classList.contains('is-active')) activeHidden = true;
    });
    if (thumbs) {
      thumbs.querySelectorAll('[data-target]').forEach(function (t) {
        var v = viewer.querySelector('li[data-media-id="' + t.dataset.target + '"]');
        t.classList.toggle('amk-hide', !!v && v.classList.contains('amk-hide'));
      });
    }
    try { if (viewer && viewer.resetPages) viewer.resetPages(); } catch (e) {}
    try { if (thumbs && thumbs.resetPages) thumbs.resetPages(); } catch (e) {}
    var active = viewer && viewer.querySelector('li[data-media-id].is-active');
    if ((activeHidden || !active || active.classList.contains('amk-hide')) && firstVisible && gallery.setActiveMedia) {
      gallery.setActiveMedia(firstVisible.dataset.mediaId, false);
    }
    markOverview(root, color);
  }
  function buildOverview(root) {
    var gallery = root.querySelector('media-gallery');
    var fs = colorFieldset(root);
    if (!gallery || !fs || root.querySelector('.amk-allcolors')) return;
    var inputs = fs.querySelectorAll('input[type=radio]');
    if (inputs.length < 2) return;
    var byColor = {};
    gallery.querySelectorAll('[id^="GalleryViewer"] li[data-media-id]').forEach(function (li) {
      var c = colorOf(li); if (!c) return;
      var img = li.querySelector('img');
      var alt = norm(img.getAttribute('alt'));
      if (!byColor[c] || (alt.indexOf('set forfra') > -1 && byColor[c].alt.indexOf('set forfra') === -1)) {
        byColor[c] = { src: img.currentSrc || img.src, alt: alt };
      }
    });
    var wrap = document.createElement('div');
    wrap.className = 'amk-allcolors';
    var h = document.createElement('p');
    h.className = 'amk-allcolors__title';
    h.textContent = 'Alle farver';
    wrap.appendChild(h);
    var grid = document.createElement('div');
    grid.className = 'amk-allcolors__grid';
    var count = 0;
    inputs.forEach(function (inp) {
      var c = norm(inp.value); var d = byColor[c]; if (!d) return;
      var b = document.createElement('button');
      b.type = 'button'; b.className = 'amk-allcolors__item'; b.dataset.color = c;
      b.setAttribute('aria-label', 'Vis farven ' + inp.value);
      var im = document.createElement('img');
      im.src = d.src.replace(/width=\d+/, 'width=240'); im.alt = ''; im.width = 120; im.height = 120; im.loading = 'lazy'; im.decoding = 'async';
      var s = document.createElement('span'); s.textContent = inp.value;
      b.appendChild(im); b.appendChild(s);
      b.addEventListener('click', function () {
        var f = colorFieldset(root); if (!f) return;
        var target = null;
        f.querySelectorAll('input[type=radio]').forEach(function (x) { if (norm(x.value) === c) target = x; });
        if (!target) return;
        var lab = f.querySelector('label[for="' + target.id + '"]');
        if (lab) lab.click(); else target.click();
      });
      grid.appendChild(b); count++;
    });
    if (count < 2) return;
    wrap.appendChild(grid);
    var anchor = fs.closest('variant-selects') || fs;
    anchor.insertAdjacentElement('afterend', wrap);
  }
  function markOverview(root, color) {
    root.querySelectorAll('.amk-allcolors__item').forEach(function (b) {
      b.classList.toggle('is-current', b.dataset.color === color);
    });
  }
  function run(root) { buildOverview(root); apply(root); }
  function roots() { var r = document.querySelectorAll('product-info'); return r.length ? r : document.querySelectorAll('.product'); }
  function init() {
    roots().forEach(function (r) {
      if (r.dataset.amkColorInit) return; r.dataset.amkColorInit = '1';
      run(r);
      r.addEventListener('change', function () { setTimeout(function () { run(r); }, 60); setTimeout(function () { run(r); }, 700); });
      new MutationObserver(function () { clearTimeout(r._amkT); r._amkT = setTimeout(function () { run(r); }, 120); })
        .observe(r, { childList: true, subtree: true });
    });
  }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', init); else init();
})();
